// extracted by mini-css-extract-plugin
export default {"BreadcrumbsMenu":"helpers_BreadcrumbsMenu__tVCqs","loader":"helpers_loader__tv21P","icon":"helpers_icon__J6iwG"};